'use strict';

var _ = require('lodash');
var moment = require('moment');
var ClassFilterBuilderService = function ClassFilterBuilderService(SearchCriteriaRule, currentStateCriteriaService, flightComponentVisibilityManagerService) {
  var weekdaysShort = moment.weekdaysShort();
  var weekdays = moment.weekdays();
  function createShortToLongWeekdaysMap() {
    var result = {};
    weekdaysShort.forEach(function (_short, index) {
      result[_short] = weekdays[index];
    });
    return result;
  }
  var shortToLongWeekdaysMap = createShortToLongWeekdaysMap();
  function createRule(fieldName, operator, leftOperandValue, rightOperandValue) {
    return new SearchCriteriaRule({
      field: fieldName,
      operator: operator,
      leftOperand: leftOperandValue,
      rightOperand: rightOperandValue
    });
  }
  function createDeparturaDateRuleFromDataSelection(selectedData, fieldName) {
    var rules = [];
    _.forEach(selectedData, function (data) {
      rules.push(createRule(fieldName, 'between', data.from.startOf('day'), data.to.endOf('day')));
    });
    return rules;
  }
  function createRuleFromDataSelection(selectedData, notSelectedData, fieldName) {
    var rules = [];
    if (selectedData.length > notSelectedData.length && notSelectedData.length !== 0) {
      _.forEach(notSelectedData, function (data) {
        rules.push(createRule(fieldName, '!=', data));
      });
    } else {
      _.forEach(selectedData, function (data) {
        rules.push(createRule(fieldName, '=', data));
      });
    }
    return rules;
  }
  function getNumberFromFlightLevels(flightLevels) {
    return _.chain(flightLevels).map(function (data) {
      return data.split(' ')[1];
    }).compact().map(function (data) {
      return parseInt(data, 10);
    }).filter(_.isFinite).value();
  }
  function handleNullSeason(rule) {
    if (rule.leftOperand === '') {
      rule.operator = 'exists';
      rule.leftOperand = false;
    }
  }
  function createSearchCriteriaRulesFromBrushSelection(selectedBrushes, notSelectedBrushes) {
    var brushRules = [];
    if (selectedBrushes.legs) {
      var legs = selectedBrushes.legs.barsWithData;
      var notSelectedLegs = notSelectedBrushes.legs;
      brushRules = _.concat(brushRules, createRuleFromDataSelection(legs, notSelectedLegs, 'custom:leg'));
    }
    if (selectedBrushes.cabin) {
      var cabins = selectedBrushes.cabin.barsWithData;
      var notSelectedCabins = notSelectedBrushes.cabin;
      brushRules = _.concat(brushRules, createRuleFromDataSelection(cabins, notSelectedCabins, 'legs.legCabins.cabinCode'));
    }
    if (selectedBrushes.flightLevel) {
      var flights = selectedBrushes.flightLevel.barsWithData;
      var notSelectedFlights = notSelectedBrushes.flightLevel || [];
      brushRules = _.concat(brushRules, createRuleFromDataSelection(getNumberFromFlightLevels(flights), getNumberFromFlightLevels(notSelectedFlights), 'number'));
    }
    if (selectedBrushes.season) {
      var seasons = selectedBrushes.season.barsWithData;
      var notSelectedSeasons = notSelectedBrushes.season;
      var seasonBrushRules = createRuleFromDataSelection(seasons, notSelectedSeasons, 'legs.legCabins.season');
      _.forEach(seasonBrushRules, handleNullSeason);
      brushRules = _.concat(brushRules, seasonBrushRules);
    }
    if (selectedBrushes.dow) {
      var dow = [];
      _.forEach(selectedBrushes.dow.barsWithData, function (data) {
        dow.push(shortToLongWeekdaysMap[data]);
      });
      var notSelectedDow = [];
      _.forEach(notSelectedBrushes.dow, function (data) {
        notSelectedDow.push(shortToLongWeekdaysMap[data]);
      });
      brushRules = _.concat(brushRules, createRuleFromDataSelection(dow, notSelectedDow, 'legs.departureDateDOW'));
    }
    if (selectedBrushes.dateRange) {
      var dateRange = [];
      _.forEach(selectedBrushes.dateRange.filterArguments[0], function (data) {
        dateRange.push(data);
      });
      brushRules = _.concat(brushRules, createDeparturaDateRuleFromDataSelection(dateRange, 'numberDepartureDate'));
    }
    return brushRules;
  }
  function createSearchCriteriaRulesFromGridSelection(selectedRows, notSelectedRows) {
    var gridRules = [];
    var isAllRowsSelected = notSelectedRows.length === 0;
    if (!isAllRowsSelected) {
      var selectedLegCabinsID = [];
      _.forEach(selectedRows, function (row) {
        selectedLegCabinsID.push(row.legCabinId);
      });
      var notSelectedLegCabinsID = [];
      _.forEach(notSelectedRows, function (row) {
        notSelectedLegCabinsID.push(row.legCabinId);
      });
      if (selectedLegCabinsID.length > notSelectedLegCabinsID.length && notSelectedLegCabinsID.length !== 0) {
        gridRules = _.concat(gridRules, createRule('legs.legCabins.legCabinId', '!=', notSelectedLegCabinsID));
      } else {
        gridRules = _.concat(gridRules, createRule('legs.legCabins.legCabinId', '=', selectedLegCabinsID));
      }
    }
    return gridRules;
  }
  function buildFilterFromGridSelectionOnly(selectedRows) {
    var rules = [];
    var selectedLegCabinsID = [];
    var selectedFlightsID = [];
    var selectedLegsID = [];
    _.forEach(selectedRows, function (row) {
      selectedLegCabinsID.push(row.legCabinId);
      selectedLegsID.push(row.legId);
      selectedFlightsID.push(row.flightId);
    });
    rules = _.concat(rules, createRule('flightId', '=', selectedFlightsID));
    rules = _.concat(rules, createRule('legs.legId', '=', selectedLegsID));
    rules = _.concat(rules, createRule('legs.legCabins.legCabinId', '=', selectedLegCabinsID));
    return rules;
  }
  function buildFilterFromChartsGridAndSearch(selectedRows, notSelectedRows) {
    var rulesFromSearch = currentStateCriteriaService.getSearchCriteria();
    var selectedBrushes = flightComponentVisibilityManagerService.getSelectedBrushes();
    var notSelectedBrushes = flightComponentVisibilityManagerService.getNotSelectedBrushes();
    var rules = [];
    rules = _.concat(rules, rulesFromSearch.rules);
    rules = _.concat(rules, createSearchCriteriaRulesFromBrushSelection(selectedBrushes, notSelectedBrushes));
    rules = _.concat(rules, createSearchCriteriaRulesFromGridSelection(selectedRows, notSelectedRows));
    return rules;
  }
  function buildFilter(selectedRows, notSelectedRows, isPostDepartureMode) {
    if (isPostDepartureMode) {
      return buildFilterFromChartsGridAndSearch(selectedRows, notSelectedRows);
    } else {
      return buildFilterFromGridSelectionOnly(selectedRows);
    }
  }
  return {
    buildFilter: buildFilter
  };
};
ClassFilterBuilderService.$inject = ['SearchCriteriaRuleFactory', 'CurrentStateCriteriaService', 'FlightComponentVisibilityManagerService'];
module.exports = ClassFilterBuilderService;